import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'A vendor-neutral visual technical reference to process control & SCADA systems: control loops, PID tuning, DCS, SCADA, industrial protocols, HMI and alarm management. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-white font-sans text-slate-600 antialiased" data-id="element-0" data-mp="sudlkfnv5z8s">
      <MetaPixel data-id="element-1" data-mp="35ypel6klo1z" />
      <main data-id="element-2" data-mp="35glr3hkw7k1">
        <Hero data-id="element-3" data-mp="356rh3pi3e8j" />
        <LookInsideCarousel data-id="element-4" data-mp="34nbvtnbp1xo" />
        <ProblemSection data-id="element-5" data-mp="3uct2jhejuizf" />
        <SystemSection data-id="element-6" data-mp="3udkos1m9b4d1" />
        <ModulesSection data-id="element-7" data-mp="3ubzw6hji5vht" />
        <BonusSection data-id="element-8" data-mp="3uevq7us8c00z" />
        <UrgencySection data-id="element-9" data-mp="d4e5zu7z1ex8" />
        <PricingSection data-id="element-10" data-mp="d4xq9hl3gfef" />
        <GuaranteeSection data-id="element-11" data-mp="d45tw4joadn3" />
        <FAQ data-id="element-12" data-mp="d2bjhk6123x9" />
        <ClosingSection data-id="element-13" data-mp="85l0op2u8u85" />
        <SummaryTable data-id="element-14" data-mp="85bcn71csx53" />
        <FinalCta data-id="element-15" data-mp="864afiic4cb3" />
      </main>
      <Footer data-id="element-16" data-mp="83qihiiybg7r" />
      <PurchaseNotification data-id="element-17" data-mp="3gl4t5lvoq8m5" />
    </div>;
}